<template>
	<div v-if="application" class="application-page">
		<b-container>
			<h1>Sicherheitsprüfung</h1>
			<p class="font-weight-extra-bold color-primary">
				Datenschutz und Anonymität sind für alle Nutzer wichtig.
			</p>
			<p>
				Fordere einen neuen Zugangscode für deine Mobilnummer an und gib diesen bitte anschließend hier ein.
			</p>
			<div v-if="success" class="success mb-3">
				Bestätigung erfolgreich. du wirst in Kürze weitergeleitet.
			</div>
			<Resend
				v-else
				type="mobilePhone"
				:resend-function="resendFunction"
				:change-function="changeFunction"
				:phone="application.phone"
				:changable="false"
				@success="onSuccess"
			/>
			<p class="mt-4">
				Diese Prüfung erfolgt, um sicherzugehen, dass ausschließlich du von diesem Zugang aus arbeitest.
			</p>
			<p class="mt-4">
				<a href="#" @click.prevent="logout">Abmelden</a>
			</p>
		</b-container>
	</div>
</template>

<script>
import Resend from "@/vue/legitimation/Resend";
import LegitimationResend from "@/api/application/legitimation/Resend";
import LegitimationChange from "@/api/application/legitimation/Change";
import Logout from "@/api/auth/Logout";
import {mapState} from "vuex";

export default {

	components: {
		Resend
	},

	data ()
	{
		return {
			success: false,
		};
	},

	computed: {
		...mapState('auth', ['application'])
	},

	methods: {
		onSuccess ()
		{
			this.success = true;

			this.redirectToLogin();
		},
		redirectToLogin ()
		{
			location.href = '/auth/login';
		},
		async resendFunction ({type})
		{
			return new LegitimationResend()
				.setType(type)
				.call();
		},
		async changeFunction ({type, code})
		{
			return new LegitimationChange()
				.setType(type)
				.setCode(code)
				.setRemoveMustReconfirmMobilePhoneOnSuccess(true)
				.call();
		},
		async logout ()
		{
			await new Logout().call();

			this.redirectToLogin();
		}
	}
}
</script>
